  import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const IciciBankBikeLoanEmi  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the ICICI Bank Bike Loan EMI Calculator?",
            "answer": "It is a tool that calculates your monthly repayment amount based on your loan amount, tenure, and interest rate."
          },
          {
            "question": "Is it free to use?",
            "answer": "Yes, TheFinMaster’s calculator is 100% free and can be used unlimited times."
          },
          {
            "question": "How accurate is the EMI calculator?",
            "answer": "It is highly accurate and reflects close-to-real EMI values based on ICICI Bank’s standards."
          },
          {
            "question": "Can I compare different tenures using the calculator?",
            "answer": "Absolutely. You can test different loan durations to find the most comfortable EMI."
          },
          {
            "question": "Does it include processing fees?",
            "answer": "The calculator does not account for processing fees. You need to add them separately."
          },
          {
            "question": "Is this applicable for all types of two-wheelers?",
            "answer": "Yes. Whether you're financing a scooter or a superbike, the calculator works for all types."
          },
          {
            "question": "What is the ideal credit score to get a lower EMI?",
            "answer": "A CIBIL score above 750 often qualifies for lower interest rates."
          },
          {
            "question": "Can I change the interest rate in the calculator?",
            "answer": "Yes. The tool allows you to input any rate to see how EMIs vary."
          },
          {
            "question": "Will the EMI remain constant?",
            "answer": "Yes, under fixed-rate loans, the EMI remains constant throughout."
          },
          {
            "question": "Can I check my total repayment amount?",
            "answer": "Yes. The calculator shows total repayment including interest."
          },
          {
            "question": "Is it mobile-friendly?",
            "answer": "Yes, it works smoothly across all mobile devices."
          },
          {
            "question": "Does the calculator provide an amortisation schedule?",
            "answer": "Yes, it shows monthly breakdowns of interest and principal."
          },
          {
            "question": "Can I download the results?",
            "answer": "Currently, it does not support downloads but you can take screenshots."
          },
          {
            "question": "Is the EMI calculator only for ICICI Bank?",
            "answer": "This page is tailored for ICICI Bank bike loans, but we have tools for other banks too."
          },
          {
            "question": "Can I use this tool before applying for a loan?",
            "answer": "Yes. It’s ideal to use the EMI calculator before you apply so you’re fully prepared."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
        <title>ICICI Bike Loan EMI Calculator – Get Instant EMI Projections</title>
        <meta  name='description' content='Plan your ICICI bike loan repayments with this fast and easy EMI calculator. Understand monthly outflows before you buy.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/icici-bank-bike-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">ICICI Bike Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
     <h1 className="text-2xl font-bold mb-4">ICICI Bike Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your ICICI Bank Bike Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Are you planning to buy your dream bike with financial assistance? TheFinMaster's ICICI Bank Bike Loan EMI Calculator is your perfect partner to plan every rupee wisely. This detailed and accurate calculator enables you to determine your monthly obligations even before you apply for the loan. Whether you're eyeing a commuter bike or a high-end superbike, understanding your EMIs in advance helps you budget smartly, compare options, and avoid any repayment stress. This tool is especially beneficial if you wish to assess different tenure and interest rate scenarios before locking your loan terms.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Bike Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Bike Loan EMI, or Equated Monthly Instalment, is the fixed monthly amount you pay to the lender against your two-wheeler loan. This amount includes both the principal repayment and the interest charged on the loan amount. EMI = Principal + Interest, spread evenly over your loan tenure. For ICICI Bank bike loans, EMIs allow you to repay the borrowed amount gradually, making two-wheeler ownership accessible without upfront strain. It provides financial convenience while maintaining liquidity.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if you take a bike loan of ₹1,00,000 for 2 years at 10.5% interest rate, your EMI would be calculated accordingly to ensure equal monthly payments.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is ICICI Bank Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The ICICI Bank Bike Loan EMI Calculator on TheFinMaster is an online utility that simulates your EMI amounts based on the inputs provided – loan amount, tenure, and interest rate. It automates complex math to give you instant, reliable EMI figures, ensuring transparent planning. It removes ambiguity by detailing the monthly burden, total interest outgo, and total repayment amount. Tailored for ICICI Bank's specific loan structure, it reflects realistic estimates you can trust.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator can be used repeatedly to compare scenarios – shorter vs. longer tenure, higher vs. lower loan amounts, or interest rate fluctuations. It eliminates guesswork from financial planning.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s ICICI Bank Bike Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Instant Results:</strong> Get your EMI, total interest payable, and total cost of the loan in seconds.</li>
                <li><strong>Zero Errors:</strong> No need for manual calculations or Excel sheets. Our tool does all the math flawlessly.</li>
                <li><strong>User-Friendly:</strong> Minimal inputs, instant outputs. Designed for everyone, not just finance experts.</li>
                <li><strong>Compare Scenarios:</strong> Change loan amounts, tenures, and rates to see how your EMIs vary.</li>
                <li><strong>Prepares You Financially:</strong> Helps you plan monthly expenses, savings, and EMIs smartly.</li>
                <li><strong>ICICI-Specific Estimates:</strong> Built for the ICICI Bank loan structure, making your estimates more accurate.</li>
                <li><strong>Free & Reusable:</strong> Use it as often as you want. No logins, no charges.</li>
              </ul>
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using our EMI Calculator ensures financial clarity and protects you from being overwhelmed by future obligations.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the ICICI Bank Bike Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              TheFinMaster’s EMI calculator works on the basic formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N - 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the principal amount</li>
              <li>R is the monthly interest rate (annual rate divided by 12)</li>
              <li>N is the number of monthly instalments</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong> Loan Amount: ₹1,20,000 Tenure: 24 months Interest Rate: 11% per annum<br />
              Monthly Interest Rate = 11 / (12 x 100) = 0.009167<br />
              EMI = [120000 x 0.009167 x (1+0.009167)^24] / [(1+0.009167)^24 - 1] ≈ ₹5,659<br />
              Thus, your EMI would be approximately ₹5,659 for 2 years.<br />
              The tool simplifies this for you – no need to use formulas manually. Just input values and get results.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a complete breakdown of your bike loan repayment plan over the entire tenure. It outlines the EMI breakup month-wise, showing how much goes towards interest and how much towards the principal every month. In early months, a larger portion of EMI goes toward interest, gradually shifting to principal repayment in later months. This table provides full transparency and helps you see the repayment journey clearly.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortisation Schedule for ICICI Bank Bike Loan:</strong> Loan Amount: ₹1,20,000 | Tenure: 12 months | Interest Rate: 11% p.a. | EMI: ₹10,577 (approx.)
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding Balance (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">1,100</td>
                    <td className="border px-4 py-2">9,477</td>
                    <td className="border px-4 py-2">1,10,523</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">1,014</td>
                    <td className="border px-4 py-2">9,563</td>
                    <td className="border px-4 py-2">1,00,960</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">928</td>
                    <td className="border px-4 py-2">9,649</td>
                    <td className="border px-4 py-2">91,311</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">837</td>
                    <td className="border px-4 py-2">9,740</td>
                    <td className="border px-4 py-2">81,571</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">745</td>
                    <td className="border px-4 py-2">9,832</td>
                    <td className="border px-4 py-2">71,739</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">658</td>
                    <td className="border px-4 py-2">9,919</td>
                    <td className="border px-4 py-2">61,820</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">567</td>
                    <td className="border px-4 py-2">10,010</td>
                    <td className="border px-4 py-2">51,810</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">476</td>
                    <td className="border px-4 py-2">10,101</td>
                    <td className="border px-4 py-2">41,709</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">383</td>
                    <td className="border px-4 py-2">10,194</td>
                    <td className="border px-4 py-2">31,515</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">289</td>
                    <td className="border px-4 py-2">10,288</td>
                    <td className="border px-4 py-2">21,227</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">195</td>
                    <td className="border px-4 py-2">10,382</td>
                    <td className="border px-4 py-2">10,845</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">10,577</td>
                    <td className="border px-4 py-2">99</td>
                    <td className="border px-4 py-2">10,478</td>
                    <td className="border px-4 py-2">0</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Interest  (₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding Balance (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "₹10,577", "₹1,100", "₹9,477", "₹1,10,523"],
          ["2", "₹10,577", "₹1,014", "₹9,563", "₹1,00,960"],
          ["3", "₹10,577", "₹928", "₹9,649", "₹91,311"],
          ["4", "₹10,577", "₹837", "₹9,740", "₹81,571"],
          ["5", "₹10,577", "₹745", "₹9,832", "₹71,739"],
          ["6", "₹10,577", "₹658", "₹9,919", "₹61,820"],
          ["7", "₹10,577", "₹567", "₹10,010", "₹51,810"],
          ["8", "₹10,577", "₹476", "₹10,101", "₹41,709"],
          ["9", "₹10,577", "₹383", "₹10,194", "₹31,515"],
          ["10", "₹10,577", "₹289", "₹10,288", "₹21,227"],
          ["11", "₹10,577", "₹195", "₹10,382", "₹10,845"],
          ["12", "₹10,577", "₹99", "₹10,478", "₹0"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
            ["1", "₹10,577", "₹1,100", "₹9,477", "₹1,10,523"],
            ["2", "₹10,577", "₹1,014", "₹9,563", "₹1,00,960"],
            ["3", "₹10,577", "₹928", "₹9,649", "₹91,311"],
            ["4", "₹10,577", "₹837", "₹9,740", "₹81,571"],
            ["5", "₹10,577", "₹745", "₹9,832", "₹71,739"],
            ["6", "₹10,577", "₹658", "₹9,919", "₹61,820"],
            ["7", "₹10,577", "₹567", "₹10,010", "₹51,810"],
            ["8", "₹10,577", "₹476", "₹10,101", "₹41,709"],
            ["9", "₹10,577", "₹383", "₹10,194", "₹31,515"],
            ["10", "₹10,577", "₹289", "₹10,288", "₹21,227"],
            ["11", "₹10,577", "₹195", "₹10,382", "₹10,845"],
            ["12", "₹10,577", "₹99", "₹10,478", "₹0"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Bike Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> A higher loan amount leads to a bigger EMI since you're repaying a larger principal over time.</li>
                <li><strong>Interest Rate:</strong> Even a slight change in interest rate can greatly affect your EMI and total repayment.</li>
                <li><strong>Loan Tenure:</strong> Longer tenures reduce EMI amounts but increase total interest paid over the loan period.</li>
                <li><strong>Processing Fees:</strong> These one-time charges increase the upfront cost and may impact your loan planning.</li>
                <li><strong>Prepayments and Foreclosure:</strong> Making early payments or closing the loan ahead of schedule can lower interest outgo.</li>
                <li><strong>Credit Profile and CIBIL Score:</strong> A strong credit score can help secure lower interest rates and better loan terms.</li>
                <li><strong>Income and Employment Stability:</strong> Higher and stable income improves loan eligibility and influences EMI affordability.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                           {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default IciciBankBikeLoanEmi ;
